export const HeaderScrollDirectiveModule = angular
    .module('app.directives.headerScroll', [])
    .directive('headerScroll', ($window) => {
        return {
            link: (scope, ele) => {
                angular.element($window).on('scroll', scrollWatcher);
                angular.element('.page').on('scroll', scrollWatcher);
                angular.element('body.safari-mobile .layout__scope').on('scroll', scrollWatcher);

                scope.$on('$destroy', () => {
                    angular.element($window).off('scroll', scrollWatcher);
                });

                function scrollWatcher(e) {
                    if (angular.element(e.target).scrollTop() > 0) {
                        ele.addClass('page__header--scroll');
                    } else {
                        ele.removeClass('page__header--scroll');
                    }
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/headerScroll.directive.js